import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";
import { AppLoadingIndicatorService } from "../../../../../../services/app-loading-indicator.service";

/**
 * Shows a loader
 */
export class ShowLoaderWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase, private appLoadingIndicator: AppLoadingIndicatorService) {
    super(injector, workplace, 'project.valuation.showLoader');
  }

  /**
  * Handles an event
  * @param payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: boolean): void {
    if (payload) {
      this.appLoadingIndicator.show();
    }
    else {
      this.appLoadingIndicator.hide();
    }
  }
}
